export const arredondaPraCima = (numero: number): number => {
  let resultado: number = numero;

  resultado = numero * 1.1;
  return resultado;
};
